import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Container from "./Container.jsx";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const link = "text-sm font-medium text-[#003366] hover:opacity-80 transition";

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200">
      <Container className="flex items-center justify-between h-16">
        <Link to="/home" className="flex items-center gap-3">
          <img src="content/images/ethira-logo.png" alt="Ethira logo" className="h-9 w-auto" />
          <span className="text-2xl font-semibold text-[#003366] tracking-tight">Ethira Property Group</span>
        </Link>

        {/* Desktop */}
        <nav className="hidden md:flex items-center gap-6" aria-label="Primary">
      
          <Link to="/types" className={link}>Strategies</Link>
           <Link to="/guides" className={link}>Investor Guides</Link>
          <Link to="/resources" className={link}>Investor Tools</Link>
           <Link to="/locations" className={link}>Locations</Link>
          <Link to="/news" className={link}>News</Link>
    
          <Link
            to="/enquire"
            className="ml-2 rounded-full px-4 py-2 text-sm font-semibold text-white bg-[#003366] border border-[#003366] hover:opacity-90"
          >
            Get Started →
          </Link>
        </nav>

        {/* Mobile trigger */}
        <button
          type="button"
          className="md:hidden inline-flex items-center justify-center rounded-xl p-2 ring-1 ring-slate-300 text-[#003366]"
          aria-controls="mobile-menu"
          aria-expanded={open ? "true" : "false"}
          onClick={() => setOpen(true)}
        >
          <span className="sr-only">Open menu</span>
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </Container>

      {/* Mobile overlay + panel */}
      {open && (
        <>
          <button
            aria-hidden="true"
            onClick={() => setOpen(false)}
            className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 md:hidden"
            tabIndex={-1}
          />
          <div
            id="mobile-menu"
            role="dialog"
            aria-modal="true"
            ref={panelRef}
            tabIndex={-1}
            className="fixed inset-x-0 top-0 z-50 md:hidden bg-white shadow-xl"
          >
            <Container className="py-4">
              <div className="flex items-center justify-between">
                <span className="text-lg font-semibold text-[#003366]">Menu</span>
                <button
                  onClick={() => setOpen(false)}
                  className="rounded-full p-2 text-[#003366] hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-[#003366]/40"
                  aria-label="Close menu"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
              </div>

              <nav className="mt-4 flex flex-col gap-3 text-[17px]" aria-label="Mobile">
                {[
                  
                  ["/types", "Strategies"],
                  ["/guides", "Investor Guides"],                 
                  ["/resources", "Investor Tools"],
                  ["/locations", "Locations"],
                  ["/news", "News"],



                ].map(([to, label]) => (
                  <Link key={to} to={to} className="py-2 text-[#003366]" onClick={() => setOpen(false)}>
                    {label}
                  </Link>
                ))}
                <Link
                  to="/enquire"
                  className="mt-2 rounded-2xl bg-[#003366] px-4 py-2 text-white text-sm font-semibold text-center"
                  onClick={() => setOpen(false)}
                >
                  Get Started →
                </Link>
              </nav>
            </Container>
          </div>
        </>
      )}
    </header>
  );
}
